module.exports = __webpack_public_path__ + "static/media/novo_globe_animation.5ebd338d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/novo_globe_animation.gif
// module id = 169
// module chunks = 0